import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formSectionSubTitle: {
    color: theme.palette.grey.grey400,
    fontWeight: 400,
    fontSize: "14px",
  },
  formSectionTitle: {
    color: "#373534",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "12px",
    display: 'flex',
    alignItems: "center"
  },
  formSectionTitleDeco: {
    width: "4px",
    height: "4px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "5px",
  },
  formConfigRuleName: {
    marginBottom: "36px"
  },
  formSectionRulesCategoriePlaceHolder: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: 14,
    marginLeft: 16,
    marginTop: 3
  },
  feedBackButtonWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    gap: "16px",
    marginTop: "43px",
  },
  configurationButtonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    gap: "20px",
  },
  recapButtonWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    gap: "16px",
  },
  recapButtonWrapperEdit: {
    justifyContent: "space-between",
  },
  summaryEditLeftBtns: {
    marginLeft: "15px"
  },
  deleteRuleImg: {
    width: "12px",
    marginRight: "12px"
  },
  disabledDeleteBtn: {
    opacity: "30%",
    cursor: "default",
  },
  summaryEditRightBtns: {
    display: "flex",
    gap: "16px"
  },
  recapWrapper: {
    backgroundColor: theme.palette.grey.grey100,
    padding: "15px",
    margin: "0 0 23px 15px",
  },
  placeHolder: {
    color: theme.palette.grey.grey400,
    fontSize: "14px",
    fontWeight: 400,
    position: "relative",
    right: "12px",
    marginLeft: "8px"
  },
  inputText: {
    position: "relative",
    top: "-2px",
    "& .MuiInputBase-root": {
      color: "#2E2E3A",
      fontSize: "14px",
      backgroundColor: "white",
      border: 0
    },
  },
  inputTextVariant: {
    "& .MuiOutlinedInput-root": {
      fontSize: "14px",
      fontWeight: 400,
      borderRadius: "16px",
      height: "40px",
      border: "1px solid #E2E2EA",
      marginTop: "8px",

      "& .MuiOutlinedInput-notchedOutline": {
        border: "0px solid #E2E2EA !important",
      },
    }
  },
  chipCrossIcon: {
    width: "7px",
    height: "7px",
  },
  valuesIconBtnClosed: {
    position: "relative",
    height: "30px"
  },
  settingicon: {
    marginRight: 4
  },
  select: {
    "& .MuiInput-input": {
      fontSize: "14px"
    },
  },
  summaryTitle: {
    fontSize: "14px",
    display: "flex"
  },
  summaryListContainer: {
    marginLeft: "20px",
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    gap: 10
  },
  summaryListTitle: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    margin: "6px 0",
    color: theme.palette.grey.grey500,
    display: "flex"
  },
  summaryListCategory: {
    display: "flex",
    backgroundColor: theme.palette.primary.primary50,
    color: theme.palette.primary.main,
    fontWeight: 400,
    padding: "4px 6px",
    borderRadius: "16px",
    position: 'relative',
    top: -4,
    margin: "0 4px"
  },
  summaryListField: {
    backgroundColor: theme.palette.grey.grey100,
    color: theme.palette.grey.grey500,
    fontWeight: 700,
    padding: "4px 8px",
    borderRadius: "16px",
    position: 'relative',
    gap: "5px",
    marginInlineEnd: "8px",
    display: "inline-block"
  },
  summaryListValue: {
    backgroundColor: theme.palette.grey.grey100,
    color: theme.palette.grey.grey500,
    fontWeight: 700,
    padding: "4px 8px",
    borderRadius: "16px",
    position: 'relative',
    gap: "5px",
    marginInlineStart: "8px",
    display: "inline-block"
  },
  summaryListIndex: {
    width: '5%',
    color: '#995C00',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.15000000596046448px',
    textAlign: 'left',
    opacity: '40%'
  },
  summaryListArrow: {
    paddingInline: '12px'
  },
  summaryActionLabel: {
    flexWrap: "wrap",
    fontSize: "14px",
    display: "flex",
    marginBlock: "8px",
    alignItems: "center"
  },
  summaryActionArrow: {
    paddingInlineEnd: "12px"
  },
  summaryRefField: {
    backgroundColor: theme.palette.grey.grey100,
    color: theme.palette.grey.grey500,
    fontWeight: 700,
    padding: "4px 8px",
    borderRadius: "16px",
    position: 'relative',
    gap: "5px",
    marginInline: "8px",
    display: "inline-block"
  },
  summaryTarget: {
    color: theme.palette.grey.grey600,
    fontSize: "14px",
    fontWeight: 600,
    margin: "0 8px",
    wordSpacing: "6px"
  },
  typeWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px"
  },

  summaryBlocLabel: {
    position: "absolute",
    display: "flex",
    top: -18,
    left: 0,
    backgroundColor: "white",
    borderTopLeftRadius: 4, borderTopRightRadius: 4,
    fontSize: "10px",
    fontWeight: 700,
    fontFamily: "Inter",
    padding: "0px 20px",
    color: "#535362",
    paddingTop: "3px",
  },
  summaryListItem: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    marginBottom: "8px",
    color: theme.palette.grey.grey700
  },
  summaryBullet: {
    marginRight: "8px",
  },
  summaryRefItem: {
    color: "#FFF",
    background: theme.palette.grey.grey700,
    border: "1px solid",
    borderColor: theme.palette.grey.grey700,
    borderRadius: "4px",
    padding: "2px 5px",
    marginLeft: "5px"
  },
  summaryRefItemValue: {
    fontWeight: 600,
  },
  summaryListOperator: {
    color: theme.palette.grey.grey700,
    fontWeight: 700,
  },
  finalizeAlertBloc: {
    marginLeft: "10px",
    fontStyle: "normal",
    fontSize: "14px",
  },
  finalizeWarningColor: {
    color: theme.palette.warning.warning600
  },
  finalizeErrorColor: {
    color: theme.palette.error.error700
  },
  finalizeAlertWarning: {
    fontWeight: 700
  },
  deleteItemIcon: {
    width: "10px"
  },
  autocompleteWrapper:{
    "& .MuiFormControl-root": {
      "& .MuiAutocomplete-input": {
        minWidth: 0
      },
    },

  },
  tagsWrapper: {
    display: "flex",
    flexDirection:"row",
    flexWrap: "wrap"
  },
  textfield: {
    "& input::placeholder": {
      fontSize: "16px",
      color: "#7E7E8F !important",
      fontStyle: "italic",
      opacity: 1,
      display: "flex"
    },
    "& .MuiInputBase-root": {
      paddingRight: "30px !important",
    },
  },
  tagsCounter: {
    color: "#9A9AAF",
    fontSize: "12px",
    fontWeight: 500,
    width:"16px",
    padding: "3px",
    marginTop: "1px",
    display:"flex",
    placeItems:"center",
    justifyContent:"center"
  },
  ruleCriteriaDeco: {
    width: 1,
    backgroundColor: theme.palette.primary.primary200,
    marginRight: 10,
  },
  addChoiceWrapper: {
    width: "100%",
    marginBottom: 39,
  },
  addChoiceBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background: theme.palette.primary.primary50,
    width: "100%",
    borderRadius: 10
  },
  actionLine: {
    position: 'relative',
    bottom: 20
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px'
  },
  flexItem: {
    flex: '1 1 0',
    minWidth: '80px',
    maxWidth: '37%', 
    alignSelf: "end"
  },
  flexStart: {
    display: 'flex',
    alignItems: "start",
  },
  flexItemIcon: {
    backgroundColor: theme.palette.primary.primary50,
    color: theme.palette.primary.primary600,
    fontWeight: 400,
    padding: "4px",
    borderRadius: "16px",
    position: 'relative',
    width: "30px", height: "30px",
    top: 2, left: -5
  },
  ruleTypeSelectInput: {
    '& .MuiSelect-select': {
        paddingRight: "24px !important"
    },
    "& .MuiInput-input": {
      fontSize: "14px"
    },
  },
  actionWrapper: {
    backgroundColor: theme.palette.grey.grey100,
    marginTop: "15px",
  },
  conditionDivider: {
    fontWeight: "700",
    color: "#656575",
    marginLeft: "14px",
    fontSize: "14px",
    alignSelf: "end"
  },
  criteriaInputsFlex: {
    display: "flex", 
    width: "100%", 
    alignItems: "start", 
    justifyContent: 
    "space-between", 
    flexWrap: "wrap", 
    rowGap: "15px"
  }
}));

export default useStyles;
